/** @format */

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Icon, Header, Divider, Button } from 'semantic-ui-react';
import _ from 'lodash';
import intl from 'react-intl-universal';
import { carSides, productConditions } from '../../../../../constants';
import RequestPartGallery from '../RequestPart/RequestPartGallery/RequestPartGallery';

@inject('CarPartsStore', 'RequestsStore', 'CarsStore')
@observer
class NewEditRequestPart extends Component {
  state = { carSides, productConditions };

  formSubmit = () => {
    const { RequestsStore } = this.props;
    if (RequestsStore.requestsParams.reqPartForm.currentPartId !== null) {
      RequestsStore.handlePartFormSubmit(
        'update',
        RequestsStore.requestsParams.currentRequestId,
      );
    } else {
      RequestsStore.handlePartFormSubmit(
        'new',
        RequestsStore.requestsParams.currentRequestId,
      );
    }
  };

  renderButton = () => {
    const { RequestsStore } = this.props;
    if (RequestsStore.requestsParams.reqPartForm.currentPartId !== null) {
      return (
        <Form.Button type="submit" color="green" fluid>
          <Icon name="save" /> {intl.get('general.save_updates')}
        </Form.Button>
      );
    } else {
      return (
        <Form.Button type="submit" color="green" fluid>
          <Icon name="plus" /> {intl.get('parts.add_part')}
        </Form.Button>
      );
    }
  };

  renderPartImg = () => {
    const { RequestsStore } = this.props;
    if (
      RequestsStore.currentReqPart.data.uploadedFile &&
      !RequestsStore.currentReqPart.data.imgUrl
    ) {
      return (
        <div style={{ position: 'relative' }}>
          <img
            alt="upload file"
            src={RequestsStore.currentReqPart.data.uploadedFile}
            style={{ width: '100%', height: 'auto' }}
          />
          <div
            className="removeImgBuotton text-red clickable"
            onClick={() => RequestsStore.removeImgFromPart()}
          >
            <strong>
              <Icon name="remove" /> {intl.get('parts.remove_image')}{' '}
            </strong>
          </div>
        </div>
      );
    }
    if (RequestsStore.currentReqPart.data.imgUrl) {
      return (
        <div style={{ position: 'relative' }}>
          <img
            alt="request part"
            src={RequestsStore.currentReqPart.data.imgUrl}
            style={{ width: '100%', height: 'auto' }}
          />
          <div
            className="removeImgBuotton text-red clickable"
            onClick={() => RequestsStore.removeImgFromPart()}
          >
            <strong>
              <Icon name="remove" /> {intl.get('parts.remove_image')}{' '}
            </strong>
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    const { RequestsStore, CarPartsStore, CarsStore } = this.props;
    const currentReqPart = RequestsStore.currentReqPart;
    let sortedCarParts = _.orderBy(CarPartsStore.getItems, ['text'], ['asc']);
    sortedCarParts = sortedCarParts.map(item => ({
      text: item.data.name,
      value: item.data.name,
      id: item.uid,
    }));

    return (
      <Modal open={RequestsStore.requestsParams.reqPartForm.open}>
        <Modal.Content>
          <Header className="modal-header" as="h3">
            <small>
              <Icon name="cogs" />
            </small>{' '}
            {intl.get('labels.part')}
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => this.formSubmit()}
          >
            <Form.Group widths="equal">
              <Form.Select
                search
                selectOnNavigation={false}
                onFocus={() => RequestsStore.resetErrorReqPart('part')}
                error={RequestsStore.requestsErrors.reqPart.includes('part')}
                name="carPart"
                value={currentReqPart.data.part}
                onChange={(e, selection) =>
                  RequestsStore.handleCarPartSelect(selection)
                }
                options={sortedCarParts}
                fluid
                label={intl.get('parts.labels.part_name')}
                placeholder={intl.get('parts.labels.part_name')}
              />
            </Form.Group>
            <Form.Group>
              <label
                htmlFor="newImage"
                style={{ cursor: 'pointer', paddingLeft: '5px' }}
              >
                <Button
                  style={{ pointerEvents: 'none', display: 'block' }}
                  type="button"
                  size="small"
                  color="green"
                >
                  <Icon name="image" />
                  {intl.get('parts.add_image')}
                </Button>
              </label>

              <Form.Input
                onChange={e => RequestsStore.addImgToPart(e)}
                style={{ display: 'none' }}
                name="newImage"
                id="newImage"
                type="file"
              />
            </Form.Group>
            <div style={{ width: '100%', height: 'auto' }}>
              {typeof currentReqPart.data.partGallery !== 'undefined' &&
              currentReqPart.data.partGallery.length !== 0 ? (
                <RequestPartGallery
                  images={currentReqPart.data.partGallery}
                  removes={true}
                  click={index => RequestsStore.removeImgFromPart(index)}
                />
              ) : null}
            </div>
            <Header as="h3">
              <small>
                <Icon name="car" />
              </small>{' '}
              {intl.get('labels.car')}
            </Header>
            <Divider />
            <Form.Group widths="equal">
              <Form.Select
                name="quickCarSelect"
                onChange={(e, selection) =>
                  RequestsStore.quickAutoSelect(selection)
                }
                search
                selectOnNavigation={false}
                options={
                  RequestsStore.carModelsOptions
                    ? RequestsStore.carModelsOptions
                    : [{ text: 'loading', value: false }]
                }
                disabled={
                  RequestsStore.currentRequest.data.carModels.length === 0
                }
                fluid
                label={intl.get('parts.labels.request_car')}
                placeholder={intl.get('parts.labels.request_car')}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Select
                onFocus={() => RequestsStore.resetErrorReqPart('carMaker')}
                error={RequestsStore.requestsErrors.reqPart.includes(
                  'carMaker',
                )}
                name="carMaker"
                value={currentReqPart.data.carMaker}
                onChange={(e, selection) =>
                  RequestsStore.handleCarMakerSelect(selection)
                }
                search
                selectOnNavigation={false}
                options={CarsStore.carsMakers}
                fluid
                label={intl.get('parts.labels.car_maker')}
                placeholder={intl.get('parts.labels.car_maker')}
              />
              <Form.Select
                search
                selectOnNavigation={false}
                onFocus={() => RequestsStore.resetErrorReqPart('carModel')}
                error={RequestsStore.requestsErrors.reqPart.includes(
                  'carModel',
                )}
                name="carModel"
                onChange={(e, selection) =>
                  RequestsStore.handleCarModelSelect(selection)
                }
                value={currentReqPart.data.carModel}
                options={CarsStore.carsModels}
                fluid
                label={intl.get('parts.labels.car_model')}
                placeholder={intl.get('parts.labels.car_model')}
              />
            </Form.Group>
            <Form.Select
              search
              selectOnNavigation={false}
              onFocus={() => RequestsStore.resetErrorReqPart('carVersion')}
              error={RequestsStore.requestsErrors.reqPart.includes(
                'carVersion',
              )}
              name="carVersion"
              onChange={(e, selection) =>
                RequestsStore.handleCarVersionSelect(selection)
              }
              value={currentReqPart.data.carVersion}
              options={CarsStore.carsVersions}
              fluid
              label={intl.get('parts.labels.car_version')}
              placeholder={intl.get('parts.labels.car_version')}
            />
            <Header as="h3">
              <small>
                <Icon name="clipboard list" />
              </small>{' '}
              {intl.get('labels.details')}
            </Header>
            <Divider />
            <Form.Group widths="equal">
              <Form.Select
                search
                selectOnNavigation={false}
                onFocus={() => RequestsStore.resetErrorReqPart('carSide')}
                error={RequestsStore.requestsErrors.reqPart.includes('carSide')}
                name="carSide"
                onChange={(e, input) =>
                  RequestsStore.handleCarPartInput(input.value, input.name)
                }
                value={currentReqPart.data.carSide}
                options={this.state.carSides}
                fluid
                label={intl.get('parts.labels.car_side')}
                placeholder={intl.get('parts.labels.car_side')}
              />
              <Form.Input
                autoComplete="off"
                name="color"
                onChange={(e, input) =>
                  RequestsStore.handleCarPartInput(input.value, input.name)
                }
                value={currentReqPart.data.color}
                fluid
                label={intl.get('parts.labels.part_color')}
                placeholder={intl.get('parts.labels.part_color')}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                autoComplete="off"
                name="productCode"
                onChange={(e, input) =>
                  RequestsStore.handleCarPartInput(input.value, input.name)
                }
                value={currentReqPart.data.productCode}
                fluid
                label={intl.get('parts.labels.part_code')}
                placeholder={intl.get('parts.labels.part_code')}
              />
              <Form.Select
                search
                selectOnNavigation={false}
                onFocus={() => RequestsStore.resetErrorReqPart('partCondition')}
                error={RequestsStore.requestsErrors.reqPart.includes(
                  'partCondition',
                )}
                name="partCondition"
                onChange={(e, input) =>
                  RequestsStore.handleCarPartInput(input.value, input.name)
                }
                value={currentReqPart.data.partCondition}
                options={this.state.productConditions}
                fluid
                label={intl.get('parts.labels.part_conditions')}
                placeholder={intl.get('parts.labels.part_conditions')}
              />
            </Form.Group>
            <Form.TextArea
              autoComplete="off"
              name="notes"
              onChange={(e, input) =>
                RequestsStore.handleCarPartInput(input.value, input.name)
              }
              value={currentReqPart.data.notes}
              label={intl.get('parts.labels.request_notes')}
              placeholder={intl.get('parts.labels.request_notes')}
            />
            <Divider />
            {this.renderButton()}
          </Form>
          <div
            className="close-button"
            onClick={() => {
              RequestsStore.togglePartForm();
              RequestsStore.resetCurrentReqPart();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default NewEditRequestPart;
